<button
  class="p-result-function__btn--favorite p-bottom-float-function-icon__btn--favorite js-add-to-favorite-btn"
  *ngIf="!this._common.isNotLogin()"
  [ngClass]="{ 'p-result-function__btn': isPc, 'is-added': this.isFavoriteAdded }"
  #add2FavoriteBtnEl
  id="complex-flight-availability-addToFavorite"
  (throttleClick$)="addToFavorite($event)"
  [disabled]="this.disabled"
  aswThrottleClick
>
  <span *ngIf="isPc && !this.isFavoriteAdded" class="p-result-function__btn-text">{{
    'm_static_message-label.addFavorite1' | staticMsg
  }}</span>
  <span *ngIf="isPc && this.isFavoriteAdded" class="p-result-function__btn-text">{{
    'm_static_message-label.RegisteredAsFavorite' | staticMsg
  }}</span>
  <span class="c-btn-add-to-favorite__icon js-add-to-favorite-icon" #add2FavoriteIconEl> </span>
</button>
